module.exports = __webpack_public_path__ + "img/c215828.jpg";